import PropTypes from "prop-types";
import React from "react";

class WorkspaceIconErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.props.onError?.(error);
  }

  render() {
    if (this.state.hasError) {
      this.setState({ hasError: false });
      return;
    }

    return this.props.children;
  }
}

WorkspaceIconErrorBoundary.propTypes = {
  onError: PropTypes.func,
};

export default WorkspaceIconErrorBoundary;
